import { api } from './networkService';

class WhatsAppMsgService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/whatsapp`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch whatsapp error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/whatsapp/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch whatsapp error:', error);
            throw error;
        }
    }

    static async add(whatsapp) {
        try {
            const cleanedWhatsappMsg = Object.fromEntries(
                Object.entries(whatsapp).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/whatsapp`, cleanedWhatsappMsg);
            return response;
        } catch (error) {
            console.error('Add whatsapp error:', error);
            throw error;
        }
    }
}

export default WhatsAppMsgService;
